import {Progress} from "antd";
import className from "classnames/bind";
import style from "../style/SeoCheck.module.scss";

const cn = className.bind(style);

/**
 * Tổng quan điểm: vòng điểm tổng (Progress dashboard) + xếp hạng + thanh điểm
 * theo từng nhóm tiêu chí.
 *
 * @param result kết quả chấm (score, grade, grade_label, grade_color, groups)
 */
function ScoreOverview({result}) {

	const {score = 0, grade, grade_label, grade_color, groups = []} = result || {};

	const color = grade_color || '#DC2626';

	return (
		<div className={cn('overview')}>
			<div className={cn('overview-score')}>
				<Progress
					type="dashboard"
					percent={score}
					strokeColor={color}
					format={(percent) => (
						<span className={cn('score-value')}>
							<strong style={{color}}>{percent}</strong>
							<small>/100</small>
						</span>
					)}
				/>
				<div className={cn('grade')} style={{color}}>
					Xếp hạng: <strong>{grade}</strong> — {grade_label}
				</div>
			</div>

			<div className={cn('overview-groups')}>
				{groups.map((g) => {
					const percent = g.max > 0 ? Math.round((g.score / g.max) * 100) : 0;
					return (
						<div className={cn('group-bar')} key={g.key}>
							<div className={cn('group-bar-head')}>
								<span>{g.label}</span>
								<span className={cn('group-bar-score')}>{g.score}/{g.max}</span>
							</div>
							<Progress percent={percent} showInfo={false} strokeColor={color} size="small" />
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default ScoreOverview;
